import api from './api';

// Mentor Code Management
export const createMentorCode = async (code = null) => {
  return await api.post('/api/mentor/code', code ? { code } : {});
};

// Mentee Management
export const getAllMentees = async () => {
  return await api.get('/api/mentor/mentees');
};

export const getMenteeDetails = async (menteeId) => {
  return await api.get(`/api/mentor/mentees/${menteeId}`);
};

// Mentee Tickets
export const getMenteeTickets = async () => {
  return await api.get('/api/mentor/tickets');
};

// Mentor Settings
export const getMentorSettings = async () => {
  return await api.get('/api/mentor/settings');
};

// Mentor Statistics
export const getMentorStats = async () => {
  return await api.get('/api/mentor/stats');
};

// Mentor cohort analytics dashboard (powers /mentor/dashboard)
export const getMentorDashboard = async () => {
  return await api.get('/api/mentor/dashboard');
};

// Job Assignment Management
export const assignJobsToMentees = async (jobIds, menteeIds) => {
  return await api.post('/api/mentor/jobs/assign', {
    job_ids: jobIds,
    mentee_ids: menteeIds
  });
};